import {DashboardConfig} from './types';

export const DEFAULT_WIDGET_ID = 999999999999;
export const DEFAULT_DASHBOARD_CONFIG: DashboardConfig = {
  widgets: [
    {
      id: DEFAULT_WIDGET_ID,
      // Rolling last 6 months
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 6)).toISOString(),
      endDate: new Date().toISOString(),
      statAggregation: 'mean',
      layerKey: 'S2_NDVI',
      sourceId: 'S2',
      title: 'Vegetation Vigor Analysis',
      timeAggregation: 'monthly',
      description: 'Average vegetation vigor over the last 6 months across all properties.',
      isPublished: true,
    },
  ],
};
